import { Component, effect, input, model, output } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { UserAvatarFileDto } from '@workspace/data-types';
import { AuraEditWrapperComponent } from '../../edit-wrapper/form-edit-wrapper.component';
import { AuraPersonAvatarDisplayComponent } from '../display/person-avatar-display.component';
import { AuraPersonAvatarFormComponent } from './form/person-identity-form.component';

@Component({
  selector: 'aura-person-avatar-edit',
  templateUrl: './person-avatar-edit.component.html',
  imports: [
    MatDividerModule,
    AuraPersonAvatarDisplayComponent,
    AuraEditWrapperComponent,
    AuraPersonAvatarFormComponent,
  ],
})
export class AuraPersonAvatarEditComponent {
  isEditing = model<boolean>(false);

  initialAvatar = input.required<UserAvatarFileDto | undefined>();
  firstName = input.required<string>();
  closeAvatarEditing = input<boolean>(false);
  avatarSaved = output<File>();

  constructor() {
    effect(() => {
      if (this.closeAvatarEditing()) {
        this.isEditing.set(false);
      }
    });
  }
}
